import { forwardRef, useEffect } from 'react'

import styled from 'styled-components'

import { useAudioStore } from 'context/AudioContext/AudioContext'

export const AudioTag = forwardRef<HTMLAudioElement>((_props, ref) => {
    const state = useAudioStore()
    const { setAudioEnd, mediaUrl, setCurrentTime, setDuration, setPlaying } =
        state

    useEffect(() => {
        if (ref && typeof ref !== 'function' && ref.current) {
            const handleTimeUpdate = () => {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                setCurrentTime(ref?.current!.currentTime)
            }

            const handleLoadedMetadata = () => {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                setDuration(ref?.current!.duration)
            }

            ref?.current.addEventListener('timeupdate', handleTimeUpdate)
            ref?.current.addEventListener(
                'loadedmetadata',
                handleLoadedMetadata
            )

            return () => {
                if (!ref?.current) {
                    return
                }

                setPlaying(false)

                ref?.current?.pause()

                ref?.current.removeEventListener('timeupdate', handleTimeUpdate)
                ref?.current.removeEventListener(
                    'loadedmetadata',
                    handleLoadedMetadata
                )
            }
        }
    }, [ref])

    return <Audio src={mediaUrl} ref={ref} onEnded={setAudioEnd} />
})

AudioTag.displayName = 'AudioTag'

const Audio = styled.audio`
    display: none;
    pointer-events: none;
`
